/* eslint-disable react/prop-types */
import React from "react";
import CustomText from "./customText";
import { Colors } from "../assets/colors";
import { Box } from "@mui/material";

function SubHeader({ heading, headerStyle }) {

  return (
    <Box sx={{...headerStyle}}>
        <CustomText
          desc={heading}
          fontFamily="Epilogue"
          colorvalue={Colors.andaihubTxt}
          style={{ ...styles.coreFeatureTxt,headerStyle }}
          title3
          fontWeight={400}
        />
      </Box>
  );
}

const styles = {
  coreFeatureTxt: {
    lineHeight: 1.5,
    fontStyle: "initial",
    textAlign: "center",
  },
};

export default SubHeader;
